// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"f6e86b95","551":"cbf74252","617":"c3cf2b45","854":"02508048","894":"a1b07075"}[chunkId] + ".chunk.js";
};